<template>
  <section class="evaluation pt-8 mx-auto w-10/12">
    <div class="row">
      <v-heading :level="3"> Contactmoment toevoegen </v-heading>
    </div>
    <div class="bg-white">
      <div class="bg-gray-100 text-lg p-5">Contactmoment toevoegen</div>
      <div class="grid gap-1 p-4">
        <label class="block text-l font-bold text-gray-700 mb-1"> Toegevoegd door * </label>
        <span>{{ currentUserIdentity.fullName }}</span>
      </div>

      <div class="grid grid-cols-2 gap-1 p-4">
        <div>
          <label class="block text-l font-bold text-gray-700 mb-1"> Datum contactmoment * </label>
          <v-input-date-picker
            id="contactDate"
            type="date"
            :rule="{ required: true }"
            v-model="contactDetails.contactDate"
            name="contactDate"
            autofocus
            @selected="handleDate"
            @blur="validateField"
          />
        </div>
      </div>
      <div class="grid gap-1 p-4">
        <label class="block text-l font-bold text-gray-700 mb-1"> Opmerkingen * </label>
        <v-textarea-group
          :v-model="contactDetails.comments"
          :rule="{ required: true }"
          :maxlength="'500'"
          label="Beschrijf hier uw contactmoment"
          :inputid="contactDetails.comments"
          @input="saveInput"
        />
        <div v-show="saveButtonClicked && !contactDetails.comments" class="form-group-simple__details">
          <div class="form-group-simple__messages">
            <div class="form-group-simple__error">* Dit veld is verplicht.</div>
          </div>
        </div>
      </div>
      <div class="flex col-2 p-5 justify-end gap-2">
        <button
          type="button"
          @click="cancel"
          class="text-white bg-gray-300 cursor-pointer border-gray-300 text-center rounded-full border w-32 h-10"
        >
          Annuleren
        </button>
        <button
          type="button"
          @click.prevent="saveContactDetails"
          :class="
            contactDetails.comments
              ? 'cursor-pointer bg-pdsPrimaryColor border-pdsPrimaryColor'
              : 'cursor-block border-gray-300 bg-gray-300'
          "
          class="text-white text-center rounded-full border w-32 h-10"
        >
          Toevoegen
        </button>
      </div>
    </div>

    <!-- Cancel pop up -->
    <modal-dialog :modal-open-status="showCancelPopUp" :showCloseButton="true" @close="closeModal()">
      <template #body>
        <p>Wilt u de contactmoment annuleren? De gegevens worden niet opgeslagen</p>
      </template>
      <template #footer>
        <v-button tagelement="button" md primary @click="goToPatientDashboard()"> Bevestigen </v-button>
      </template>
    </modal-dialog>
    <!-- Success pop up -->
    <modal-dialog :modal-open-status="showSuccessPopup" :showCloseButton="true" @close="closeModal()">
      <template #body>
        <p>Uw contactmoment is opgeslagen en toegevoegd aan het patiënt dashboard</p>
      </template>
      <template #footer>
        <v-button tagelement="button" md primary @click="goToPatientDashboard()"> Naar patiënt dashboard </v-button>
      </template>
    </modal-dialog>
  </section>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { useStore } from 'vuex';
import { ref, computed } from 'vue';
import VInputDatePicker from '@/components/shared/form/simple/InputDatePicker';
import { currentUserIdentity$ } from '@/services';
import VTextareaGroup from '@/components/shared/form/TextareaGroup';
import router from '@/router';

export default {
  name: 'ContactMomenten',
  components: {
    VInputDatePicker,
    VTextareaGroup
  },

  setup() {
    const store = useStore();
    const currentUserIdentity = ref(null);
    const contactDetails = ref({
      contactDate: '',
      comments: '',
      customerId: '',
      licenseId: 0,
      userId: 0,
      userName: ''
    });
    const showCancelPopUp = ref(false);
    const showSuccessPopup = ref(false);
    currentUserIdentity$.subscribe((value) => {
      currentUserIdentity.value = value;
    });
    const patientDetails = computed(() => store.getters['patient/getPatientGegevens']);
    const handleDate = (key, value) => {
      contactDetails.value.contactDate = moment(value, 'DD-MM-YYYY').format('YYYY-MM-DD');
    };
    const saveInput = (event) => {
      contactDetails.value.comments = event.target ? event.target.value : '';
    };
    const saveContactDetails = () => {
      contactDetails.value.userId = currentUserIdentity.value.id;
      contactDetails.value.licenseId = router.currentRoute.value.params.licenseId;
      contactDetails.value.userName = currentUserIdentity.value.fullName;
      contactDetails.value.customerId = patientDetails.value.PatientId;
      axios.post('Osa/SaveOsaContactDetail', contactDetails.value).then((response) => {
        if (response && response.data.Success) {
          showSuccessPopup.value = true;
        }
      });
    };
    const cancel = () => {
      showCancelPopUp.value = true;
    };
    const closeModal = () => {
      showSuccessPopup.value = false;
      showCancelPopUp.value = false;
    };
    const goToPatientDashboard = () => {
      router.push('/patientdashboard');
    };
    return {
      contactDetails,
      handleDate,
      saveContactDetails,
      currentUserIdentity,
      saveInput,
      cancel,
      showCancelPopUp,
      showSuccessPopup,
      closeModal,
      goToPatientDashboard
    };
  }
};
</script>
